import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { initialStateSlice } from "../../initialStateSlice";

const tourSlice = createSlice({
  name: "tour",
  initialState: initialStateSlice,
  reducers: {
    set_tour: (state, action) => {
      return action.payload;
    },
  },
});

export const { set_tour } = tourSlice.actions;
export default tourSlice;

export const fetchTour = createAsyncThunk(
  "reference/tour/fetchTour",
  async (payload, { getState }) => {
    return null;
  }
);
